/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  isLocalStorageAvailable.ts
 */

let localStorageAvailable: boolean

// https://stackoverflow.com/a/16427747
export const isLocalStorageAvailable = () => {
  if (localStorageAvailable !== undefined) {
    return localStorageAvailable
  }
  try {
    const test = '__local-storage-available-test__'
    const localStorage = (global as unknown as Window).localStorage
    if (!localStorage) {
      localStorageAvailable = false
      return false
    }
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    localStorageAvailable = true
    return true
  } catch (e) {
    localStorageAvailable = false
    return false
  }
}
